import React, { useState, useEffect, useContext } from 'react'
import { LanguageCurrencyContext } from '@context/LanguageCurrencyContext';
import axios from '@fetch/axios';
import Spinner from '@components/Spinner';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

function DiscountPopup({ onClose }) {
    const [showPopup, setShowPopup] = useState(() => {
        // Verificar si existe en localStorage
        const storedValue = localStorage.getItem('arteonu_discount_popup');
        return storedValue == null;
    });
    const MySwal = withReactContent(Swal)
    const [loading, setLoading] = useState(true)
    const [email, setEmail] = useState('');
    const [emailError, setEmailError] = useState('');
    const { lang } = useContext(LanguageCurrencyContext);
    const [discount, setDiscount] = useState(null);
    // Expresión regular para validar formato de email
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    const fetchDiscount = async () => {
        try{
            const data = await axios.get('/buy-incentive?lang=' + lang)
            setDiscount(data.data);

        }catch(err){
            handleClose();
        }
    }

    // Guardar en localStorage cuando se cierre el popup
    useEffect(() => {
        if (!showPopup) {
            localStorage.setItem('arteonu_discount_popup', 'true');
        }
        fetchDiscount();
    }, [showPopup]);

    // Función para sanitizar el input - solo permite caracteres válidos para email
    const sanitizeEmail = (value) => {
        // Eliminar caracteres peligrosos: solo permite letras, números y caracteres específicos de email
        // Elimina: < > " ' ` { } [ ] ( ) ; : = & | \ / * ? ~ ! @ # $ % ^
        const sanitized = value.replace(/[^a-zA-Z0-9@._%+-]/g, '');
        return sanitized;
    };

    // Función para validar el formato del email
    const validateEmail = (value) => {
        if (!value) {
            setEmailError(lang === 'es'
                ? 'El email es requerido'
                : 'Email is required');
            return false;
        }

        if (!emailRegex.test(value)) {
            setEmailError(lang === 'es'
                ? 'Por favor ingresa un email válido'
                : 'Please enter a valid email');
            return false;
        }

        // Validaciones adicionales de seguridad
        // Prevenir emails con caracteres sospechosos incluso si pasan el regex
        const suspiciousPatterns = [
            /<script/i,
            /javascript:/i,
            /on\w+\s*=/i, // event handlers como onclick, onerror, etc.
            /data:text\/html/i,
            /vbscript:/i
        ];

        for (let pattern of suspiciousPatterns) {
            if (pattern.test(value)) {
                setEmailError(lang === 'es'
                    ? 'Email no válido. Caracteres no permitidos detectados'
                    : 'Invalid email. Suspicious characters detected');
                return false;
            }
        }

        setEmailError('');
        return true;
    };

    // Manejar cambio en el input
    const handleEmailChange = (e) => {
        const value = e.target.value;
        // Sanitizar el valor antes de establecerlo
        const sanitizedValue = sanitizeEmail(value);
        setEmail(sanitizedValue);

        // Limpiar error cuando el usuario está escribiendo
        if (emailError) {
            setEmailError('');
        }
    };

    // Validar al perder el foco
    const handleEmailBlur = () => {
        validateEmail(email);
    };

    const handleClose = () => {
        setShowPopup(false);
        if (onClose) {
            onClose();
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validar el email antes de enviar
        if (!validateEmail(email)) {
            return;
        }

        // Sanitizar el email una vez más antes de enviar
        const finalEmail = sanitizeEmail(email);
        setLoading(false)
        try{
            const data = await axios.post('/buy-incentive/subscribe?lang=' + lang, { email: finalEmail, incentive_id: discount.id });
            setLoading(true)
              MySwal.fire({
				text: data.data,
				icon: 'success',
			})
            localStorage.setItem('arteonu_discount_popup', 'true');
            handleClose();
        }catch(err){
            setLoading(true)
            MySwal.fire({
				text: err.response.data,
				icon: 'error',
				title: 'Oops...'
			})
			return;
        }


    };

    if (!showPopup) {
        return null;
    }

    return (
        <>
        {!loading && <Spinner />}

        {discount && (<div className="popup-overlay" style={{ zIndex: 1001 }}>
            <div className="popup-content discount-popup-content">
                <button className="close-btn" onClick={handleClose} aria-label="Close">
                </button>

                <div className="grid">
                    <div>
                        <div className="ImageIcon ArtOnU" style={{ cursor: "pointer" }} ></div>
                        <div className="discount-message">
                            <div className="discount-box">
                                {discount ? discount.title : ''}
                            </div>
                        </div>

                        <form onSubmit={handleSubmit} className="discount-form">
                            <div className={`FormData ${emailError ? 'InvalidInput' : ''}`}>
                                <em>{lang === 'es' ? 'Email' : 'Email'}</em>
                                <div className="FormInputLight">
                                    <input
                                        type="email"
                                        value={email}
                                        onChange={handleEmailChange}
                                        onBlur={handleEmailBlur}
                                        placeholder={lang === 'es' ? 'Ingresa tu email aquí...' : 'Enter your email here...'}
                                        required
                                        maxLength={254}
                                        autoComplete="email"
                                    />
                                </div>
                                {emailError && (
                                    <em className="InfoData">{emailError}</em>
                                )}
                            </div>
                            <button type="submit" className="ButtonDark discount-submit-btn">
                                {discount ? discount.button_text : ''}
                            </button>
                        </form>
                    </div>
                    <div>
                        <picture>
                            <source
                                media="(max-width: 800px)"
                                srcSet={discount ? discount.image_mobile : ''}
                            />
                            <img
                                src={discount ? discount.image : ''}
                                alt="Logo"
                                className="popup-img"
                            />
                        </picture>
                    </div>

                </div>
            </div>
        </div>)}
        </>
    );
}

export default DiscountPopup;

